<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mcc-row">

                <section class="mcc-col mu-d-flex mu-flex-row">
                    <h1 class="mu-mb-00">Applications </h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>

                </section>
                <section class="mcc-col mu-d-flex mu-justify-content-end mu-align-items-center">
                    <div role="group" class="mcc-button-group">
                        <router-link :to="CONTEXT_PATH + '/design/applications/new'">
                            <button class="mcc-button mcc-button--primary" id="addApplicationBtn" title="Add application">
                                <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add application</span>
                            </button>
                        </router-link>

                    </div>

                </section>
            </div>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li>Applications</li>

            </ol>
        </nav>

        <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="filterTable" title="Application Filters">
           
                <section class="mcc-card mu-border-0">
                    <div class="mcc-row" v-show="!dataCall">
                        <div>
                            <form id="formIdd">
                            <div>
                                <div class="mfc-input-wrapper mfc-form-input-container mu-mb-03">
                                    <label for="name">Name</label>
                                    <input type="text" name="application-name" maxlength="50" id="name" :pattern="nameRegex" :value="applicationNameRef" @change="applicationNameRef = $event.target.value">

                                </div>

                                <div class="mfc-slim-select-wrapper mu-mb-03">
                                    <label for="slim-select_multiple">Tags</label>
                                    <select id="slim-select_multiple" class="mfc-slim-select" aria-label="multiple_radio_input" @change="selectedLabelRef = $event.target.value" multiple>
                                        <option v-for="label in applications" :selected="selectedLabelRef.indexOf(label) > -1" :key="label" :value="label">{{label}}</option>
                                    </select>
                                </div>
                                <div class="mt-2">
                                    <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                        <fieldset class="mfc-fieldset">
                                            <legend class="mfc-label">
                                                Deployed
                                            </legend>
                                            <div class="mcc-segmented-buttons__list" ref="radioRef" name="deployed-radioGroup" id="deployed-radioGroup">
                                                <input id="Deployed_button1" name="Deployed-choice-button-group" type="radio" value="yes" @click="deployedRef = $event.target.value" :checked="deployedRef =='yes'">
                                                <label class="mcc-segmented-buttons__button" for="Deployed_button1">
                                                    <span class="mcc-segmented-buttons__label">Yes</span>
                                                </label>
                                                <input id="Deployed_button2" name="Deployed-choice-button-group" type="radio" value="no" @click="deployedRef = $event.target.value" :checked="deployedRef =='no'">
                                                <label class="mcc-segmented-buttons__button" for="Deployed_button2">
                                                    <span class="mcc-segmented-buttons__label">No</span>
                                                </label>
                                                <input id="Deployed_button3" name="Deployed-choice-button-group" type="radio" value="all" @click="deployedRef = $event.target.value" :checked="deployedRef =='all'">
                                                <label class="mcc-segmented-buttons__button" for="Deployed_button3">
                                                    <span class="mcc-segmented-buttons__label">All</span>
                                                </label>

                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                        <fieldset class="mfc-fieldset">
                                            <legend class="mfc-label">
                                                Disabled
                                            </legend>
                                            <div class="mcc-segmented-buttons__list" ref="disabledRadioRef" name="disabled-radioGroup" id="disabled-radioGroup">
                                                <input id="Disabled_button1" name="Disabled-choice-button-group" type="radio" value="yes" @click="disabledRef = $event.target.value" :checked="disabledRef =='yes'">
                                                <label class="mcc-segmented-buttons__button" for="Disabled_button1">
                                                    <span class="mcc-segmented-buttons__label">Yes</span>
                                                </label>
                                                <input id="Disabled_button2" name="Disabled-choice-button-group" type="radio" value="no" @click="disabledRef = $event.target.value" :checked="disabledRef =='no'">
                                                <label class="mcc-segmented-buttons__button" for="Disabled_button2">
                                                    <span class="mcc-segmented-buttons__label">No</span>
                                                </label>
                                                <input id="Disabled_button3" name="Disabled-choice-button-group" type="radio" value="all" @click="disabledRef = $event.target.value" :checked="disabledRef =='all'">
                                                <label class="mcc-segmented-buttons__button" for="Disabled_button3">
                                                    <span class="mcc-segmented-buttons__label">All</span>
                                                </label>

                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                        <fieldset class="mfc-fieldset">
                                            <legend class="mfc-label">
                                                Protected
                                            </legend>
                                            <div class="mcc-segmented-buttons__list" ref="protectedRadioRef" name="protected-radioGroup" id="protected-radioGroup">
                                                <input id="Protected_button1" name="Protected-choice-button-group" type="radio" value="yes" @click="protectedRef = $event.target.value" :checked="protectedRef =='yes'">
                                                <label class="mcc-segmented-buttons__button" for="Protected_button1">
                                                    <span class="mcc-segmented-buttons__label">Yes</span>
                                                </label>
                                                <input id="Protected_button2" name="Protected-choice-button-group" type="radio" value="no" @click="protectedRef = $event.target.value" :checked="protectedRef =='no'">
                                                <label class="mcc-segmented-buttons__button" for="Protected_button2">
                                                    <span class="mcc-segmented-buttons__label">No</span>
                                                </label>
                                                <input id="Protected_button3" name="Protected-choice-button-group" type="radio" value="all" @click="protectedRef = $event.target.value" :checked="protectedRef =='all'">
                                                <label class="mcc-segmented-buttons__button" for="Protected_button3">
                                                    <span class="mcc-segmented-buttons__label">All</span>
                                                </label>

                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                        </form>

                        </div>

                    </div>
                </section>
           
        </Drawer>
        <div class="mcc-row">
            <div class="mcc-col">
                <div class="mcc-card">
                    <div v-if="!updateCall" class="spinner-overlay ">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex ">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                </circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <div class="mcc-card__body">
                        <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                            <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : '(3)'}}</span>
                            </button>
                        </div>
                        <div>
                            <div>
                                <div class="mcc-table-toolbar" v-show="selectedApplications.length>0">
                                    <div class="mcc-table-batch-actions mcc-table-batch-actions--active">
                                        <div class="mcc-table-batch-actions__summary">
                                            <p class="mu-mb-00">{{selectedApplications.length}} {{ selectedApplications.length > 1 ? 'rows selected' : 'row selected'}}</p>
                                        </div>
                                        <div class="mcc-table-batch-actions__list">
                                            <div class="mcc-button-group mcc-button-group--spaced">
                                                <button class="mcc-button mcc-button mu-border mu-border-ui-01" @click="exportApplications()" id="exportApplicationBtn" title="Export applications" v-show="selectedApplications.length>0">
                                                    <mcc-icon name="export" aria-hidden="true"></mcc-icon><span class="mcc-button__label"></span>
                                                    <label>Export applications</label>
                                                </button>
                                                <button id="cancelBtn" class="mcc-button mcc-button--icon-only mcc-button--sm mcc-button--primary" @click="uncheckAll">
                                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon>
                                                    <span class="mcc-button__label">Cancel</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <mcc-data-table ref="applicationTable" id="applicationTableId"></mcc-data-table>

                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import ApplicationAPI from "../../../services/ApplicationAPI";
import Table from "@advanced/component-mosaic-table";
import ImportExportAPI from "../../../services/ImportExportAPI";
import Utils from "@/script_utils";
import Drawer from "../../common/Drawer.vue";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "ApplicationHome",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["application.list"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            nameRegex: constantMessages.PATTERNS["name"],
            searchCriteria: {},
            applications: {},
            selectedLabelRef: "",
            selectedLabels: "",
            applicationName: "",
            deployedType: "all",
            disabledType: "no",
            protectedType: "all",
            applicationNameRef: "",
            deployedRef: "all",
            disabledRef: "no",
            protectedRef: "all",
            selectedForm: [],
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            dataCall: true,
            disableActionArray: [],
            selectedApplications: [],
            responseData: [],
            pageStart: -1,
            filterCount: 0,
            tableData: [],
            filterActive: false,
            filterData: [],
            tagInstance: null,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        if (localStorage.getItem("application") === "application") {

            let storedAppName = localStorage.getItem("DataTables_" + window.location.pathname + "_applicationName");

            if (storedAppName != null && storedAppName != "") {
                this.applicationNameRef = storedAppName;
                this.applicationName = storedAppName;
            }

            let storedDeploy = localStorage.getItem("DataTables_" + window.location.pathname + "_deployedType");

            if (storedDeploy != null && storedDeploy != "") {
                this.deployedRef = storedDeploy;
                this.deployedType = storedDeploy;
            }

            let storedDisable = localStorage.getItem("DataTables_" + window.location.pathname + "_disabledType");

            if (storedDisable != null && storedDisable != "") {
                this.disabledRef = storedDisable;
                this.disabledType = storedDisable;
            }

            let storedProtect = localStorage.getItem("DataTables_" + window.location.pathname + "_protectedType");

            if (storedProtect != null && storedProtect != "") {
                this.protectedRef = storedProtect;
                this.protectedType = storedProtect;
            }

            let selectedLabelRefString = localStorage.getItem("DataTables_" + window.location.pathname + "_selectedLabels");

            if (selectedLabelRefString != "" && selectedLabelRefString != null) {
                this.selectedLabelRef = selectedLabelRefString.split(",");
                this.selectedLabels = this.selectedLabelRef;
            }

            let storedSize = localStorage.getItem("applicationHomePageSize");
            if (storedSize != null && storedSize != "") {
                this.currentPageSize = parseInt(storedSize);
            }
            localStorage.removeItem("applicationHomePageSize");
            localStorage.removeItem("application");

            localStorage.removeItem("DataTables_" + window.location.pathname + "_applicationName");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_deployedType");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_disabledType");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_protectedType");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_selectedLabels");
            this.filterCount = parseInt(localStorage.getItem("setFilterDataInLocalStorage"));
            localStorage.removeItem("setFilterDataInLocalStorage");
        }
        this.initApplicationsTable();
        this.tagInstance = new SlimSelect({
            select: '#slim-select_multiple',
            settings: {
                closeOnSelect: false,
            },
        });

        ApplicationAPI.getApplicationLabels()
            .then(result => {
                this.applications = result;
            })
            .finally(() => {});
    },
    methods: {
        getFilterCount() {
            if (this.selectedLabelRef != "")
                this.filterCount += 1;
            if (this.applicationNameRef != "")
                this.filterCount += 1;
            if (this.deployedRef != "")
                this.filterCount += 1;
            if (this.disabledRef != "")
                this.filterCount += 1;
            if (this.protectedRef != "")
                this.filterCount += 1;
        },
        filterTable(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.filterCount = 0;
            this.getFilterCount();
            this.selectedLabels = this.tagInstance.getSelected();
            this.applicationName = this.applicationNameRef;
            this.deployedType = this.deployedRef;
            this.disabledType = this.disabledRef;
            this.protectedType = this.protectedRef;
            this.initApplicationsTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        uncheckAll() {
            let self = this;
            const selectedList = document.querySelectorAll("#applicationTableId input[type=checkbox]:checked");

            selectedList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            self.selectedApplications = [];
        },
        resetFilter() {
            this.updateCall = false;
            this.filterCount = 0;
            this.deployedRef = "all";
            this.disabledRef = "no";
            this.protectedRef = "all";
            this.protectedType = "all";
            this.selectedLabelRef = "";
            this.tagInstance.setSelected([]);
            this.applicationNameRef = "";
            this.selectedLabels = "";
            this.applicationName = "";
            this.deployedType = "all";
            this.disabledType = "no";
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.initApplicationsTable();
        },
        updateTemplate() {
            let self = this;
            this.$refs.applicationTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(self.CONTEXT_PATH + "/design/applications/" + reference.trim());
                        }

                    });
                });
            $(".tagLabels").each((a, obj) => {
                let text1 = $(obj)
                    .text()
                    .split(",");
                let htmlTag = "";
                text1.forEach(b => {
                    if (b != "") {
                        htmlTag += '<span class="mcc-chip mcc-chip--soft-info mcc-chip--xs mu-mr-03">'+ b + " </span>";
                    }
                });
                $(obj).html(htmlTag);
            });
        },
        initApplicationsTable() {
            let self = this;
            self.selectedApplications = [];
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const filesTable = document.querySelector('#applicationTableId');
            this.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No applications found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        select: {
                            type: "boolean",
                            format: "checkbox",
                            title: "Select",
                            editable: true
                        },
                        name: {
                            type: "string",
                            title: "Name",
                            sortable: true,
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            columnSearch: false
                        },
                        labels: {
                            type: "string",
                            title: "Tags",
                            template: '<div class="tagLabels">{{labels}}</div>',
                            sortable: false,
                            columnSearch: false
                        },
                        prettyDeploymentTime: {
                            type: "string",
                            title: "Last deployed",
                            sortable: false,
                            template: '<div><u>{{prettyDeploymentTime}}</u><div>{{deploymentTime}}</div></div>',
                            columnSearch: false
                        },
                        disabled: {
                            type: "string",
                            title: "Disabled",
                            sortable: false,
                            columnSearch: false
                        },
                        protectedLabel: {
                            type: "string",
                            title: "Protected",
                            sortable: false,
                            columnSearch: false
                        },
                        actions: {
                            type: "object",
                            title: "Actions",
                            properties: {
                                deploymentAction: {
                                    type: "string",
                                    format: "button",
                                    title: "View deployment",
                                    color: "success",
                                    iconOnly: false
                                }
                            }
                        }
                    }
                },
                data: (start, limit, sortHeader, sortDirection, fullTextQuery, searchColumns) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        self.pageStart = start;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }

                        let disabledYes = self.disabledType == "yes" || self.disabledType == "all";
                        let disabledNo = self.disabledType == "no" || self.disabledType == "all";
                        let queryString = "start=" +

                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&name=" +
                            self.applicationName +
                            "&labelIds=" +
                            self.selectedLabels +
                            "&cYes=" +
                            disabledYes +
                            "&cNo=" +
                            disabledNo +
                            "&deployed=" +
                            self.deployedType +
                            "&isProtected=" +
                            self.protectedType;
                        let searchColumnsList = [];
                        return ApplicationAPI.getAppliations(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;

                            if (result.data != null) {
                                responseData.data = result.data;
                                // console.log(responseData.data);
                                responseData.data.forEach(function (obj, index) {
                                    obj.select = self.selectedApplications.indexOf(obj.id) != -1;
                                    obj["disabledCheckbox"] = obj.deleted != null;
                                    let actionsObj = {
                                        deploymentAction: {
                                            hidden: obj.deploymentTime == null,
                                            disabled: !self.$store.getters.getRoleAdmin
                                        }
                                    };
                                    obj["actions"] = actionsObj;
                                    obj.deploymentTime = obj.deploymentTime == null ? "" :
                                        Utils.getMomentDateString(obj.deploymentTime);
                                    obj.prettyDeploymentTime = obj.prettyDeploymentTime == null ? "" :
                                        obj.prettyDeploymentTime;
                                });
                            }
                            self.responseData = responseData.data;
                            self.tableData = responseData.data;
                            this.dataCall = false;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        this.dataCall = false;
                        return responseData;
                    }
                },
                onAction: (table, action, rowObj) => {
                    if (action == "select") {
                        rowObj.forEach((obj, a) => {
                            if (obj.value &&
                                self.selectedApplications.indexOf(obj.rowData.id) == -1) {
                                self.selectedApplications.push(obj.rowData.id);
                            } else if (!obj.value) {
                                self.selectedApplications.splice(self.selectedApplications.indexOf(obj.rowData.id), 1);
                            }
                        });
                    } else if (action == "deploymentAction") {
                        self.$router.push(self.CONTEXT_PATH +
                            "/processengine/deployment/" +
                            rowObj[0].rowData.deploymentId);
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.responseData.forEach((item, index) => {
                        if (item.disabledCheckbox) {
                            // self.tableObj.disableRowActions(self.pageStart + index);
                        }
                    });
                    self.updateCall = true;
                    self.updateTemplate();
                }
            });
        },
        setFilterDataInLocalStorage() {
            // localStorage.setItem("applicationHomePageSize", this.tableObj.tableContext.store.state.pageSize);
            localStorage.setItem("DataTables_" + window.location.pathname + "_applicationName", this.applicationName);
            localStorage.setItem("DataTables_" + window.location.pathname + "_deployedType", this.deployedType);
            localStorage.setItem("DataTables_" + window.location.pathname + "_disabledType", this.disabledType);
            localStorage.setItem("DataTables_" + window.location.pathname + "_protectedType", this.protectedType);
            localStorage.setItem("DataTables_" + window.location.pathname + "_selectedLabels", this.selectedLabels);
            localStorage.setItem("applicationListFilterCount", this.filterCount);

        },
        exportApplications() {
            ImportExportAPI.exportFiles("APPLICATION", this.selectedApplications.toString());
        }
    },
};
</script>

<style scoped>
</style>
